import CONSTANTS from './product/CONSTANTS';

import { compose, tap, thunkify, call, prop } from 'ramda'
import keysToLowerCase from './product/allKeysToLowercase'
import axiosGetFullProductJSON from './product/axiosGetFullProductJSON'
import mapOptionsByImageIndex from './product/mapOptionsByImageIndex'
import getSizedImage from './product/getSizedImage'
import getImageUrlByPosition from './product/getImageUrlByPosition'
import getCurrentSelectedOptionsFromSelects from './product/getCurrentSelectedOptionsFromSelects'
import updatePrice from './product/updatePrice'
import updateVariantFormField from './product/updateVariantFormField'
import switchStockDisplay from './product/switchStockDisplay'
import getVariantFromVariantsAndOptions from './product/getVariantFromVariantsAndOptions'
import updateVariantUrl from './product/updateVariantUrl'
import variantColorSelector from './product/variantColorSelector'
import setActiveThumbnail from './product/setActiveThumbnail'
import setImageUrl from './product/setImageUrl';
import getMatchingOptionsFromImageIndex from './product/getMatchingOptionsFromImageIndex'
import getClosestOptionsToCurrentlySelected from './product/getClosestOptionsToCurrentlySelected'
import getVariantById from './product/getVariantById'
import getCurrentVariant from './product/getCurrentVariant'
import returnParamAlternativelyReturnFunctionCall from './product/returnParamAlternativelyReturnFunctionCall'
import updateSelects from './product/updateSelects'
import getThumbnailPosition from './product/getThumbnailPosition'
import updateRawSrc from './product/updateRawSrc'
import Swiper from 'swiper';

const defaults = keysToLowerCase(CONSTANTS);

/**
 * 
 * option defaults from contants:
 * product_form_selector: "[data-product-form]"
 * product_option_select_selector: "[data-option-select]"
 * product_main_image_selector: "[data-main-product-image]"
 * product_variant_id_form_field: "[data-product-form] [name="id"]"
 * product_image_thumbs_selector: "[data-product-thumbnail-index]"
 * product_image_thumbs_attr: "data-product-thumbnail-index"
 * product_thumbnail_active_class: "active"
 * product_stock_wrapper_attr: "data-product-in-stock"
 * product_oos_text_attr: "data-oos-text"
 * product_in_stock_text_attr: "data-in-stock-text"
 * product_unavailable_text_attr: "data-unavailable-text"
 * product_form_submit_button_selector: "[data-product-form-submit]"
 * product_price_selector: "[data-product-price]"
 * product_compare_at_price_selector: "[data-product-compare-at-price]"
*/

export const productInit = async (options, productUpdatedCallBack = (variant) => variant) => {
  console.log('pdp loaded')

  const opts = Object.assign({}, defaults, options)

  const productForm = document.querySelector(opts.product_form_selector)
  if (!productForm) {
    return false;
  }

  //get the data
  const getThisProductsJSON = axiosGetFullProductJSON(productForm.dataset.productForm);
  const productData = await getThisProductsJSON()
  const optionsByImageIndex = mapOptionsByImageIndex(productData.variants)

  //get all the elements 
  const variantIdFormField = document.querySelector(opts.product_variant_id_form_field)
  const atcButton = document.querySelector(opts.product_form_submit_button_selector);
  const priceEls = document.querySelectorAll(opts.product_price_selector)
  const subSavingPriceEls = document.querySelectorAll(opts.product_sub_saving_price_selector)
  const compareAtpriceEls = document.querySelectorAll(opts.product_compare_at_price_selector)
  const mainImage = document.querySelector(opts.product_main_image_selector)
  const optionSelects = document.querySelectorAll(opts.product_option_select_selector)
  const imageThumbs = document.querySelectorAll(opts.product_image_thumbs_selector)

  //configure up the functions
  const updateProductVariantFormField = updateVariantFormField(variantIdFormField, productData.handle);
  const updateProductPrice = updatePrice(priceEls, compareAtpriceEls, subSavingPriceEls, window.theme.moneyFormat)
  const getSizedImageFromConfig = getSizedImage('1000x1000')
  const setMainImageUrl = setImageUrl(mainImage);
  const updateMainImageRawSrc = updateRawSrc(mainImage);
  const setProductActiveThumbnail = setActiveThumbnail(imageThumbs, opts.product_image_thumbs_attr, opts.product_thumbnail_active_class);

  const stockMap = (() => {
    try { return JSON.parse(productForm.getAttribute(opts.product_stock_map)) }
    catch (e) { console.info('No stockmap on product form'); return {} }
  })();

  const switchProductStockDisplay = switchStockDisplay({
    stockWrapper: productForm,
    stockWrapperAttr: opts.product_stock_wrapper_attr,
    atcButton, oosAttr: opts.product_oos_text_attr,
    inStockAttr: opts.product_in_stock_text_attr,
    preOrderAttr: opts.product_pre_order_text_attr,
    unavailableAttr: opts.product_unavailable_text_attr
  });
  const getAvailabilityFlag = (variant) => variant ? stockMap[variant.id.toString()] : 'unavailable';
  const updateStockDisplay = compose(switchProductStockDisplay, getAvailabilityFlag)


  const updateVariantData = compose(
    tap(productUpdatedCallBack),
    tap(updateProductVariantFormField),
    tap(updateProductPrice),
    tap(updateVariantUrl),
    tap(updateStockDisplay),
    returnParamAlternativelyReturnFunctionCall(getCurrentVariant(productData.variants)(variantIdFormField))
  )

  const updateProductToMatchThumbnail = compose(
    updateVariantData,
    getVariantById(productData.variants),
    prop('id'),
    tap(compose(updateSelects(optionSelects), prop('options'))),
    getClosestOptionsToCurrentlySelected(getCurrentSelectedOptionsFromSelects(optionSelects)),
    getMatchingOptionsFromImageIndex(optionsByImageIndex)
  )
  window.blubolt.updateProductByImagePosition = updateProductToMatchThumbnail;

  const updateProductSlide = variant => {
    if (window.blubolt.glides['product-image-slider']) {
      if (variant.featured_image) {
        const position = variant.featured_image ? variant.featured_image.position === 1 ? variant.featured_image.position : variant.featured_image.position - 1 : -1;
        window.blubolt.glides['product-image-slider'].go(`=${position - 1}`);
      }
      else {
        window.blubolt.glides['product-image-slider'].go(`=${0}`);
      }
    }

    return;
  }

  const onSelectChange = thunkify(
    compose(
      updateProductSlide,
      updateVariantData,
      getVariantFromVariantsAndOptions(productData.variants),
      call,
      getCurrentSelectedOptionsFromSelects
    )
  );

  const onProductThumbnailClick = thunkify(
    compose(
      setMainImageUrl,
      getSizedImageFromConfig,
      tap(updateMainImageRawSrc),
      getImageUrlByPosition(productData.images),
      tap(updateProductToMatchThumbnail),
      tap(setProductActiveThumbnail),
      getThumbnailPosition(opts.product_image_thumbs_attr)
    )
  );

  [...optionSelects].forEach(select => select.addEventListener('change', onSelectChange([...optionSelects])));

  [...imageThumbs].forEach(thumbnail => thumbnail.addEventListener('click', onProductThumbnailClick(thumbnail)));

  window.blubolt.selectZoomImage = (imagePosition) => {
    const thumbnail = document.querySelector(`[data-product-thumbnail-index="${imagePosition}"]`);
    if (!thumbnail) {
      console.error('could not find the image selected', imagePosition);
      return;
    }

    (onProductThumbnailClick(thumbnail))(null);
  }
}